import React, {useContext} from 'react';
import { Route, Switch, useLocation, BrowserRouter as Router } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import Header from './components/Header';
import Footer from './components/Footer';
import AlertDialog from './components/AlertDialog';
import ConfirmDialog from './components/ConfirmDialog';
import routes, { ProtectedRoute } from "./router"; 
import ScrollToTop from './components/ScrollToTop';
import './App.scss';
import {StoreContext} from "./store/context";
import CircularProgress from '@material-ui/core/CircularProgress';
import {
    TransitionGroup,
    CSSTransition
} from "react-transition-group";
import {ROLE_ADMIN, ROLE_EMPLOYEE} from "./utils/constants"
import {ViewportProvider} from "./components/viewport";

const renderComponents = (role) => routes.map((route, index) => {
    if (route.isProtected){
        if (route.role && route.role.includes(role)){
            return (<ProtectedRoute
                path={route.path}
                exact={route.exact}
                component={route.component}
                key={index}
            />);
        } else {
            return;
        }
    }
    else {
        return (
            <Route
                path={route.path}
                exact={route.exact}
                component={route.component}
                key={index}
            />
        )
    };
});

const tagManagerArgs = {}

if (process.env.REACT_APP_ENV === "production") {
  tagManagerArgs.gtmId = 'GTM-5PRD99J'
} else {
  tagManagerArgs.gtmId = 'GTM-5MSZK7N'
}

TagManager.initialize(tagManagerArgs)


const App = () =>{
    const { state } = useContext(StoreContext);
    const { showAppBar } = state.generalStates;
    return (
        <>
          <Router>
              <ViewportProvider>
                <ScrollToTop />
                <Container />
              </ViewportProvider>
          </Router>
        </>
    );
}

const Container = () =>{
    const { state } = useContext(StoreContext);
    const { showAppBar, isLoading } = state.generalStates;
    const role = sessionStorage.getItem("role");
    const location = useLocation();
    return (
        <>
            { showAppBar ?
                <Header>
                    {isLoading && <CircularProgress className="page-loader-with-nav-drawer"/>}
                    <TransitionGroup className="transition-group">
                        <CSSTransition
                            key={location.key}
                            timeout={{ enter: 500, exit: 500 }}
                            classNames={'fade'}
                        >
                            <section className="route-section">
                                <Switch location={location}>{renderComponents(role)}</Switch>
                            </section>
                        </CSSTransition>
                    </TransitionGroup>
                </Header> :
                <div>
                    {isLoading && <CircularProgress className="page-loader-without-nav-drawer"/>}
                    <TransitionGroup className="transition-group">
                        <CSSTransition
                            key={location.key}
                            timeout={{ enter: 500, exit: 500 }}
                        >
                            <section className="route-section">
                                <Switch location={location}>{renderComponents(role)}</Switch>
                            </section>
                        </CSSTransition>
                    </TransitionGroup>
                </div>
            }
            <ConfirmDialog/>
            <AlertDialog/>
        </>
    );
}

export default App;
